import { useState } from 'react';

const FAQS = [
  {
    q: 'Are there cabins near Glen Falls in Highlands, NC?',
    a: 'Yes, there are cabins located near Glen Falls waterfall in Highlands, NC. Staying near Glen Falls provides easy access to one of the most scenic waterfalls in the area. Glen Falls Luxury Cabin in Highlands, NC is one of the closest and most popular options, known for its location, privacy, and high guest ratings.',
  },
  {
    q: 'What is the closest cabin to Glen Falls in Highlands, NC?',
    a: 'Glen Falls Luxury Cabin in Highlands, NC is widely considered the closest and most highly rated cabin option near Glen Falls. It sits in a peaceful wooded setting just minutes from the trailhead and consistently earns a 5.0-star rating as an Airbnb Guest Favorite.',
  },
  {
    q: 'How far is Glen Falls from downtown Highlands, NC?',
    a: 'Glen Falls is located just a few minutes by car from downtown Highlands, making it one of the most accessible waterfalls in the area. Cabins near Glen Falls are typically within a 5–10 minute drive of downtown restaurants, shops, and galleries.',
  },
  {
    q: 'Are there pet-friendly cabins near Glen Falls in Highlands, NC?',
    a: 'Yes, Glen Falls Luxury Cabin in Highlands, NC is pet friendly and is one of the most popular options for guests traveling with dogs. The wooded setting and proximity to trails make it a natural fit for pet owners looking to stay near the falls.',
  },
  {
    q: 'What is Glen Falls like in Highlands, NC?',
    a: 'Glen Falls is a multi-tiered waterfall in Highlands, NC that drops through a forested gorge in three distinct cascades. A scenic hiking trail runs alongside the falls, offering views at each level. It is accessible year-round and is considered one of the most beautiful waterfalls in the Highlands area.',
  },
  {
    q: 'What are the best things to do near Glen Falls in Highlands, NC?',
    a: 'Visitors staying near Glen Falls can hike the Glen Falls trail, explore nearby Dry Falls and Bridal Veil Falls, hike Whiteside Mountain, and enjoy the restaurants and shops of downtown Highlands — all within a short drive of the falls.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (i: number) => setOpenIndex(openIndex === i ? null : i);

  return (
    <section className="bg-[#F5F1EB] py-24 px-6 lg:px-14">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-14">
          <p className="text-[#C9A96E] text-xs tracking-[0.35em] uppercase font-jost mb-4">/ Common Questions</p>
          <h2 className="font-cormorant text-5xl text-[#1A1A18] font-light">
            Frequently Asked<br /><em className="italic">Questions</em>
          </h2>
        </div>
        <div className="space-y-3">
          {FAQS.map((faq, i) => (
            <div key={faq.q} className="bg-white rounded-2xl overflow-hidden">
              <button
                onClick={() => toggle(i)}
                className="w-full flex items-center justify-between gap-4 p-7 text-left cursor-pointer"
              >
                <span className="font-cormorant text-xl text-[#1A1A18] font-medium leading-snug">{faq.q}</span>
                <div
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F5F1EB] shrink-0 transition-transform duration-300"
                  style={{ transform: openIndex === i ? 'rotate(45deg)' : 'rotate(0deg)' }}
                >
                  <i className="ri-add-line text-[#2D4A3E]" />
                </div>
              </button>
              {openIndex === i && (
                <div className="px-7 pb-7">
                  <div className="w-full h-px bg-[#F5F1EB] mb-5" />
                  <p className="text-[#5C5850] text-sm font-jost leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
